module.exports = __webpack_public_path__ + "static/media/cemetery_road_small.c0aeca74.jpg";